import RemoveCIDModalContentContainer from './RemoveCIDModalContentContainer';

export default RemoveCIDModalContentContainer;
